import { render, staticRenderFns } from "./AmbientiLavoro_Tab6.vue?vue&type=template&id=405b56d9&scoped=true&"
import script from "./AmbientiLavoro_Tab6.vue?vue&type=script&lang=js&"
export * from "./AmbientiLavoro_Tab6.vue?vue&type=script&lang=js&"
import style0 from "./AmbientiLavoro_Tab6.vue?vue&type=style&index=0&id=405b56d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b56d9",
  null
  
)

export default component.exports